import { setLevel, parseLogLevel } from './logLevelManager';

export function initializeUrlLogLevelSupport(): void {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const logLevelParam = urlParams.get('logLevel') || urlParams.get('log-level');

    if (!logLevelParam) {
      return;
    }

    const level = parseLogLevel(logLevelParam);

    if (level === null) {
      return;
    }

    setLevel(level);

    // Clean up URL
    if (window.history && window.history.replaceState) {
      urlParams.delete('logLevel');
      urlParams.delete('log-level');
      const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;

      window.history.replaceState({}, '', newUrl);
    }
  } catch (error) {
    console.error('Failed to initialize URL log level support:', error);
  }
}
